import { useState, useMemo, useCallback } from 'react';

const useEventFilters = ({ defaultQuery }) => {
  const [selectedFilter, setSelectedFilter] = useState('status');
  const [searchInput, setSearchInput] = useState('');
  const [appliedSearchTerm, setAppliedSearchTerm] = useState('');

  const [selectedStatus, setSelectedStatus] = useState([]);

  const currentQuery = useMemo(() => {
    const query = { ...defaultQuery };
    if (appliedSearchTerm) {
      query.event_id = appliedSearchTerm;
    }

    if (selectedStatus.length > 0) {
      query.status = selectedStatus;
    }

    return query;
  }, [defaultQuery, appliedSearchTerm, selectedStatus]);

  const handleFilterChange = useCallback((event) => setSelectedFilter(event.target.value), []);

  const handleSearchChange = useCallback((event) => setSearchInput(event.target.value), []);

  const handleSearchKeyPress = (event) => {
    if (event.key === 'Enter') {
      setAppliedSearchTerm(searchInput.trim());
    }
  };

  const handleStatusChange = (statuses) => {
    setSelectedStatus(Array.isArray(statuses) ? statuses : []);
  };

  return {
    selectedFilter,
    searchTerm: searchInput,
    selectedStatus,
    currentQuery,
    handleFilterChange,
    handleSearchChange,
    handleSearchKeyPress,
    handleStatusChange,
    appliedSearchTerm,
  };
};

export default useEventFilters;
